import { type StackProps, Stack } from "@volca/ui/components/ui/stack";
import { cn } from "@volca/ui/lib/utils";
import { PAYROLL_PANE_FILL_CLASS_NAME } from "./payroll-grid-layout";

interface PayBreakdownPaneShellProps extends StackProps {
  fillHeight?: boolean;
}

export const PayBreakdownPaneShell = ({
  className,
  fillHeight = false,
  gap = 4,
  ...props
}: PayBreakdownPaneShellProps) => (
  <Stack
    gap={gap}
    align="start"
    className={cn(
      "w-full min-w-0",
      {
        [PAYROLL_PANE_FILL_CLASS_NAME]: fillHeight,
      },
      className,
    )}
    {...props}
  />
);
